import React from 'react';
import { connect } from 'react-redux';

import { getTranslation } from '../../translation/translation';
import { trackVisit } from '../../logger/googleAnalytics';
import { renderOneImagePage } from '../../components/oneImagePage/oneImagePage';

interface NotMobileErrorProp {
    textNotMobile: string;
}

class NotMobileError extends React.Component<NotMobileErrorProp> {
    public componentDidMount() {
        trackVisit('notmobile');
    }

    public render() {
        return renderOneImagePage('/seic_website/assets/image/illustration-08.png', this.props.textNotMobile);
    }
}

const mapStateToProps = (state: any) => {
    return {
        textNotMobile: getTranslation(state, 13),
    };
}

export default connect(mapStateToProps)(NotMobileError);
export const NotMobileErrorComponent = NotMobileError;